// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5066":"dcc34ab9","5478":"c6be04b2"}[chunkId] + ".chunk.js";
};